import { render } from "./AutoGrid.vue?vue&type=template&id=5287ee2a"
import script from "./AutoGrid.vue?vue&type=script&lang=js"
export * from "./AutoGrid.vue?vue&type=script&lang=js"

import "./AutoGrid.vue?vue&type=style&index=0&id=5287ee2a&lang=scss"

import exportComponent from "/Users/Max/Documents/Projekte/slf-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__